import React from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import "../styles/UserForm.css";
import logo from "../assets/logo.png";

const UserForm = ({
  title,
  subtitle,
  buttonText,
  userType,
  setUserType,
  username,
  setUsername,
  password,
  setPassword,
  errors,
  designation,
  setDesignation,
  location,
  locationOptions,
  onSubmit,
  errorMessage,
  successMessage,
  showForgotPassword,
  loading,
  isAdmin,
  locationOptionsWithSelectAll,
  handleLocationChange,
  outletOptionsWithSelectAll,
  handleOutletChange,
  selectedOutletOptions
}) => {
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };
  
  const designationOptions = [
    { value: "IT", label: "IT" },
    { value: "City Chef", label: "City Chef" },
    { value: "Cluster Manager", label: "Cluster Manager" },
    { value: "Director", label: "Director" },
    { value: "Operation Manager", label: "Operation Manager" }
  ]

  const userOptions = [
    { value: "Admin", label: "Admin" },
    { value: "User", label: "User" }
  ]
  return (
    <div className="card">
      <img src={logo} alt="Manis Logo" className="logo" />
      <h2 className="title">{title}</h2>
      <p className="subtitle">{subtitle}</p>

      {errorMessage && <div className="error">{errorMessage}</div>}
      {successMessage && <div className="success">{successMessage}</div>}

      <form onSubmit={handleFormSubmit}>
        <div className="form-group">
          <label>Username</label>
          <input
            type="email"
            value={username}
            onChange={setUsername}
            placeholder="Enter Username"
          />
          {errors.username && (
            <small className="error-text">{errors.username}</small>
          )}
        </div>
        
        {buttonText === "Login" && (
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={setPassword}
              placeholder="Enter Password"
            />
            {errors.password && (
              <small className="error-text">{errors.password}</small>
            )}
          </div>
        )}

        {buttonText !== "Login" && (
          <>
            <div className="form-group">
              <label htmlFor="designation">Designation</label>
              <Select
                inputId="designation"
                options={designationOptions}
                value={designationOptions.find(opt => opt.value === designation) || null}
                onChange={(option) => setDesignation(option?.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="locations">Select Locations</label>
              <Select
                inputId="locations"
                isMulti
                closeMenuOnSelect={false}
                options={locationOptionsWithSelectAll}
                value={locationOptions.filter(opt =>
                  location.includes(opt.value)
                )}
                onChange={handleLocationChange}
                isDisabled={!isAdmin}
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Locations..."
              />
            </div>
            <div className="form-group">
              <label htmlFor="outlets">Select Outlets</label>
              <Select
                inputId="outlets"
                isMulti
                closeMenuOnSelect={false}
                options={outletOptionsWithSelectAll}
                value={selectedOutletOptions}
                onChange={handleOutletChange}
                placeholder={
                  location.length ? "Select outlets..." : "Select Locations First"
                }
              />
            </div>
            <div className="form-group">  
              <label htmlFor="usertype">User Type</label>
              <Select
                inputId="usertype"
                options={userOptions}
                value={userOptions.find(opt => opt.value === userType) || null}
                onChange={(option) => setUserType(option?.value)}
              />
            </div>
          </>
        )}

        <button
          className="button"
          type="submit"
          disabled={loading}
        >
          {loading ? "Submitting" : buttonText}
        </button>
      </form>

      {showForgotPassword && (
        <div className="forgot-password">
          <span onClick={() => navigate("/forgot-password")}>
            Forgot password?
          </span>
        </div>
      )}
    </div>
  );
};

export default UserForm;
